import { defineRecipe } from "@chakra-ui/react";

const headingRecipe = defineRecipe({
  base: {
    fontWeight: "bold",
  },
  variants: {
    size: {
      xl: {
        textStyle: "3xl",
        md: { textStyle: "4xl" },
      },
    },
  },
});

export default headingRecipe;
